import { render } from "./WeekDays.vue?vue&type=template&id=0e10931c&scoped=true"
import script from "./WeekDays.vue?vue&type=script&lang=js"
export * from "./WeekDays.vue?vue&type=script&lang=js"

import "./WeekDays.vue?vue&type=style&index=0&id=0e10931c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e10931c"]])

export default __exports__